export default "__VITE_ASSET__Ddptrt2f__"